export enum EBitfStrapiQueryOperator {
  AND = '$and',
  OR = '$or',
}
